var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaLoadBalancersDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic load balancer",
    clipPath: "url(#clip0_9146_76174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic load balancer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49968 16.6693H3.33301C1.95217 16.6693 0.833008 15.5501 0.833008 14.1693V5.83594C0.833008 4.4551 1.95217 3.33594 3.33301 3.33594H7.49968C8.88051 3.33594 9.99968 4.4551 9.99968 5.83594V14.1693C9.99968 15.5501 8.88051 16.6693 7.49968 16.6693Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5003 7.5H15.8337C14.9128 7.5 14.167 6.75417 14.167 5.83333V4.16667C14.167 3.24583 14.9128 2.5 15.8337 2.5H17.5003C18.4212 2.5 19.167 3.24583 19.167 4.16667V5.83333C19.167 6.75417 18.4212 7.5 17.5003 7.5Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5003 16.6641H15.8337C14.9128 16.6641 14.167 15.9182 14.167 14.9974V13.3307C14.167 12.4099 14.9128 11.6641 15.8337 11.6641H17.5003C18.4212 11.6641 19.167 12.4099 19.167 13.3307V14.9974C19.167 15.9182 18.4212 16.6641 17.5003 16.6641Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M14.167 5.83105H13.75C13.29 5.83105 12.917 6.2049 12.917 6.66406V12.4971C12.917 12.9562 13.29 13.3311 13.75 13.3311H14.167V14.9971H13.75C12.3717 14.9971 11.25 13.8754 11.25 12.4971V10.4141H10V8.74707H11.25V6.66406C11.25 5.28573 12.3717 4.16406 13.75 4.16406H14.167V5.83105Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.08333 7.5H3.75C3.06 7.5 2.5 6.94083 2.5 6.25C2.5 5.55917 3.06 5 3.75 5H7.08333C7.77333 5 8.33333 5.55917 8.33333 6.25C8.33333 6.94083 7.77333 7.5 7.08333 7.5Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.08333 10.8359H3.75C3.06 10.8359 2.5 10.2768 2.5 9.58594C2.5 8.8951 3.06 8.33594 3.75 8.33594H7.08333C7.77333 8.33594 8.33333 8.8951 8.33333 9.58594C8.33333 10.2768 7.77333 10.8359 7.08333 10.8359Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.41699 15C6.10735 15 6.66699 14.4404 6.66699 13.75C6.66699 13.0596 6.10735 12.5 5.41699 12.5C4.72664 12.5 4.16699 13.0596 4.16699 13.75C4.16699 14.4404 4.72664 15 5.41699 15Z",
    fill: "#BFDFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLoadBalancersDefault);
export default __webpack_public_path__ + "static/media/figma-load-balancers-default.adfaee30d7cc33534fa11dfcd83f93f4.svg";
export { ForwardRef as ReactComponent };